module.exports = __webpack_public_path__ + "static/11gde-110335999efd8c94a16078eb1872129d.gif";